export default {
  most_popular: '#{{rank}} Cel mai apreciat',
};
